import React from 'react';
import PropTypes from 'prop-types';
import TagManager from 'react-gtm-module';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';
import {
  Wrapper,
  Title,
  Text,
  Button,
  BannerImage,
  LinkButton
} from './styles';

const FidelizePromotionalBanner = ({
  backgroundColor,
  bannerTitle,
  bannerText,
  bannerButton,
  redirectButtonVisible,
  columnsWidths,
  firstColumnImage,
  lastColumnImage
}) => {
  const handleButtonClick = () => {
    const { externalId, userId } = JSON.parse(
      window.localStorage.getItem('broker')
    );
    TagManager.dataLayer({
      dataLayer: {
        event: 'ClickFidelizeBannerButton',
        userId,
        brokerId: externalId
      }
    });
    window.open(getSessionItem('PLATAFORMA_FIDELIZE'), '_blank');
  };

  const renderBannerTitle = () => {
    const { fontSize, lineHeight, content, color } = bannerTitle;

    return (
      <Title fontSize={fontSize} lineHeight={lineHeight} color={color}>
        {content}
      </Title>
    );
  };

  const renderBannerText = () => {
    const { fontSize, lineHeight, content, color } = bannerText;

    return (
      <Text fontSize={fontSize} lineHeight={lineHeight} color={color}>
        {content}
      </Text>
    );
  };

  const renderBannerButton = () => {
    const { type, variant, size, text } = bannerButton;
    const ComponentToUse = type === 'button' ? Button : LinkButton;
    return (
      <ComponentToUse
        type="button"
        variant={variant}
        size={size}
        onClick={() => handleButtonClick()}
      >
        {text}
      </ComponentToUse>
    );
  };

  return (
    <Wrapper columnsWidths={columnsWidths} backgroundColor={backgroundColor}>
      <div>
        {firstColumnImage && <BannerImage {...firstColumnImage} alt="first" />}
      </div>
      <div>
        {bannerTitle && renderBannerTitle()}
        {bannerText && renderBannerText()}
        {redirectButtonVisible && renderBannerButton()}
      </div>
      <div>
        {lastColumnImage && <BannerImage {...lastColumnImage} alt="last" />}
      </div>
    </Wrapper>
  );
};

FidelizePromotionalBanner.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  bannerTitle: PropTypes.object,
  bannerText: PropTypes.object,
  bannerButton: PropTypes.object.isRequired,
  redirectButtonVisible: PropTypes.bool.isRequired,
  columnsWidths: PropTypes.array.isRequired,
  firstColumnImage: PropTypes.object.isRequired,
  lastColumnImage: PropTypes.object.isRequired
};

export default FidelizePromotionalBanner;
